export const DEV = process.env.NODE_ENV === 'development';
export const BACK_URL = process.env.REACT_APP_PUBLIC_API_URL;
export const TIMEOUT = 10 * 1000;
